import { render, staticRenderFns } from "./SlideBar.vue?vue&type=template&id=0c815ca3&"
import script from "./SlideBar.vue?vue&type=script&lang=ts&"
export * from "./SlideBar.vue?vue&type=script&lang=ts&"
import style0 from "./SlideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports